module.exports = __webpack_public_path__ + "static/media/Bulk_Manual_Exports_Sample.1bb466a2.csv";